var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.floorBase),function(i){return _c('div',{key:i.floor},[_c('SingleFloor',{attrs:{"floorData":i}})],1)}),_vm._l((_vm.floorSurface),function(i){return _c('div',{key:i.floor},[_c('SingleFloor',{attrs:{"floorData":i}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }